import { Box } from "@chakra-ui/react"
import { ActivitiesTableAdvanced } from "@hydrologiq/shared/components/activities"
import { useActivities } from "@hydrologiq/shared/hooks/activities"

const PAGE_SIZE = 10

function OrdersActivities() {
  // Activities hook - skip initial fetch since it's not the default view
  const {
    activities,
    pagination: activitiesPagination,
    loading: activitiesLoading,
    refreshing: activitiesRefreshing,
    error: activitiesError,
    filters: activitiesFilters,
    sort: activitiesSort,
    defaultFilters: activitiesDefaultFilters,
    defaultSort: activitiesDefaultSort,
    filterOptions: activitiesFilterOptions,
    fetchActivities,
    setFilters: setActivitiesFilters,
    setSort: setActivitiesSort,
    clearFilters: clearActivitiesFilters,
    refetch: refetchActivities,
  } = useActivities(PAGE_SIZE, true, undefined, false)

  return (
    <ActivitiesTableAdvanced
      activities={activities}
      loading={activitiesLoading}
      refreshing={activitiesRefreshing}
      error={activitiesError}
      onRetry={refetchActivities}
      filterOptions={activitiesFilterOptions}
      defaultSortAsc={false}
      allowDelete
      serverPagination={
        activitiesPagination
          ? {
              pagination: activitiesPagination,
              onPageChange: (page: number) =>
                fetchActivities(page, activitiesPagination.per_page, activitiesFilters, activitiesSort),
              onPageSizeChange: (pageSize: number) => fetchActivities(1, pageSize, activitiesFilters, activitiesSort),
            }
          : undefined
      }
      serverFiltering={{
        filters: activitiesFilters,
        sort: activitiesSort,
        defaultFilters: activitiesDefaultFilters,
        defaultSort: activitiesDefaultSort,
        onFiltersChange: setActivitiesFilters,
        onSortChange: setActivitiesSort,
        onClearAll: clearActivitiesFilters,
      }}
      useGroups
    />
  )
}
export default OrdersActivities
